<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
			<div>
				
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 140px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">采集表类型:</label>
				<el-select  v-model="filterForm.acquireType" placeholder="全部" style="width: 140px;">
					<el-option label="全部" value="all"></el-option>
					<el-option label="电表" value="0"></el-option>
					<el-option label="水表" value="1"></el-option>
					<el-option label="气表" value="2"></el-option>
					<el-option label="其他" value="3"></el-option>
				</el-select>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">采集表名称:</label>
				<el-input style="width: 180px;font-size: 14px;" placeholder="请输入采集表名称" v-model="filterForm.acquireName">
				</el-input>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">传感器编号:</label>
				<el-input style="width: 180px;font-size: 14px;" placeholder="请输入传感器编号" v-model="filterForm.sn">
				</el-input>
				<br/>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">表名称/户号:</label>
				<el-input style="width: 160px;font-size: 14px;" placeholder="请输入表名称/户号" v-model="filterForm.addressName">
				</el-input>
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
				<div style="display:inline;">
					<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="startMonth" value-format="yyyyMMdd"  format="yyyyMMdd" type="date" :placeholder="startMonthValue" @change="startMonthOnChange"></el-date-picker>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 6px 6px 6px 6px;box-sizing: border-box;">-</label>
					<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="endMonth" value-format="yyyyMMdd" format="yyyyMMdd" type="date"  :placeholder="endMonthValue" @change="endMonthOnChange"></el-date-picker>
				</div>
				<el-button style="margin-left: 10px;" @click="queryBtn()">查询</el-button>
				<el-button v-if="permissionNodeList.CJBSJJL_export.hasEntitle == 1" @click="exportData">数据导出</el-button>
			</div>
		</el-col>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="140" sortable>
			</el-table-column>
			<el-table-column prop="addressName" label="表名称/户号" width="180" sortable>
			</el-table-column>
			<el-table-column prop="acquireName" label="采集表名称" width="180"  sortable>
			</el-table-column>
			<el-table-column prop="upTimeStr" label="采集时间" width="150" sortable>
			</el-table-column>
			<el-table-column prop="dataType" label="采集结果" width="120" sortable>
			</el-table-column>
			<el-table-column prop="acquiseContent" label="采集内容" width="350" sortable>
				<template scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.acquiseContent" placement="top-start">
				     <lable style="font-size:12px;" v-if="scope.row.acquiseContent.length>50">{{ scope.row.acquiseContent.slice(0,50) + '...' }}</lable>
					 <lable style="font-size:12px;" v-if="scope.row.acquiseContent.length<=50">{{ scope.row.acquiseContent }}</lable>
				    </el-tooltip>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				permissionNodeList:global.getPermissionNodeList(),
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				cmptTypeList:[],
				editFormVisible: false,
				editLoading: false,
				
				addForm: {

				},
				editForm: {

				},
				filterForm: {
					
				},
				sysAppList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterCmptType:'',
				projectList:[],
				startMonth: '',
				endMonth:'',
				startMonthValue:'',
				//tools.getCurrentYear()+'01',
				endMonthValue:'',
				//tools.getCurrentYear()+'12',
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			startMonthOnChange(val) {  
				this.startMonthValue = val;  
			},
			endMonthOnChange(val) {  
				this.endMonthValue = val;
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					acquireName:this.filterForm.acquireName,
					addressName:this.filterForm.addressName,
					acquireType:this.filterForm.acquireType,
					sn:this.filterForm.sn,
					pageNum: this.page,
					pageSize: 15
				};
				if((!tools.strIsEmpty(this.startMonthValue))&&(!tools.strIsEmpty(this.endMonthValue))){
					var starttime = new Date(this.startMonthValue.toString().substr(0,4),this.startMonthValue.toString().substr(4,2)-1,this.startMonthValue.toString().substr(6,2),'00','00','00').getTime();
					var endtime = new Date(this.endMonthValue.toString().substr(0,4),this.endMonthValue.toString().substr(4,2)-1,this.endMonthValue.toString().substr(6,2),'23','59','59').getTime();
					if(starttime>endtime){
						tools.error(new Vue(),"开始日期不能比结束日期大");
						return;
					}
					if((endtime - starttime) > (31536000000/12)){
						tools.error(new Vue(),"暂不支持超过一月范围的查询");
						return;
					}
					param.startTime = starttime;
					param.endTime = endtime;
				}
				
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterForm.acquireType && this.filterForm.acquireType.length>0) {
					if(this.filterForm.acquireType == 'all')param.acquireType = '';
					else param.acquireType = this.filterForm.acquireType;
				}
				if(null != this.filterForm.acquireName && this.filterForm.acquireName.length>0) param.acquireName = this.filterForm.acquireName;
				if(null != this.filterForm.addressName && this.filterForm.addressName.length>0) param.addressName = this.filterForm.addressName;
				if(null != this.filterForm.sn && this.filterForm.sn.length>0) param.sn = this.filterForm.sn;
				this.listLoading = true;
				api.acquireData_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					if (res.data.list) {
						this.list_data.forEach(one => {
							if(one.dataType == '-1'){
								one.dataType = '采集异常';
							}
							else if(one.dataType == '0'){
								one.dataType = '正常';
							}
					    });
					}
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				if(null != param.cmptType){
					if(param.cmptType == 'all')this.filterCmptType = '';
					else this.filterCmptType = param.cmptType;
				}
				this.get_list_data();
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseInt(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					    console.log(temp);
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					acquireName:this.filterForm.acquireName,
					addressName:this.filterForm.addressName,
					acquireType:this.filterForm.acquireType,
					sn:this.filterForm.sn,
				};
				if((!tools.strIsEmpty(this.startMonthValue))&&(!tools.strIsEmpty(this.endMonthValue))){
					var starttime = new Date(this.startMonthValue.toString().substr(0,4),this.startMonthValue.toString().substr(4,2)-1,this.startMonthValue.toString().substr(6,2),'00','00','00').getTime();
					var endtime = new Date(this.endMonthValue.toString().substr(0,4),this.endMonthValue.toString().substr(4,2)-1,this.endMonthValue.toString().substr(6,2),'23','59','59').getTime();
					if(starttime>endtime){
						tools.error(new Vue(),"开始日期不能比结束日期大");
						return;
					}
					if((endtime - starttime) > (31536000000/12)){
						tools.error(new Vue(),"暂不支持超过一月范围的查询");
						return;
					}
					param.startTime = starttime;
					param.endTime = endtime;
				}
				
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterForm.acquireType && this.filterForm.acquireType.length>0) {
					if(this.filterForm.acquireType == 'all')param.acquireType = '';
					else param.acquireType = this.filterForm.acquireType;
				}
				if(null != this.filterForm.acquireName && this.filterForm.acquireName.length>0) param.acquireName = this.filterForm.acquireName;
				if(null != this.filterForm.addressName && this.filterForm.addressName.length>0) param.addressName = this.filterForm.addressName;
				if(null != this.filterForm.sn && this.filterForm.sn.length>0) param.sn = this.filterForm.sn;
				this.listLoading = true;
				api.acquireData_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'acquiredataList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
					this.listLoading = false;
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				this.listLoading = true;
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			}
		},
		mounted() {
			this.get_list_data();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// acquire_data_list.vue?d1ea9b74